import { createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "col-xs-12 col-sm-12"
};
const _hoisted_2 = {
    class: "row",
    style: { "max-height": "calc(100vh - 250px)", "min-height": "300px" }
};
const _hoisted_3 = { class: "text-center bottom10" };
const _hoisted_4 = { class: "col-xs-4 col-sm-4 col-md-4 tile_stats_count" };
const _hoisted_5 = { class: "fs-3 fw-bold" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "Total", -1 /* HOISTED */);
const _hoisted_7 = { class: "col-xs-4 col-sm-4 col-md-4 tile_stats_count healthy" };
const _hoisted_8 = { class: "fs-3 fw-bold" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "Licensed", -1 /* HOISTED */);
const _hoisted_10 = { class: "col-xs-4 col-sm-4 col-md-4 tile_stats_count critical" };
const _hoisted_11 = { class: "fs-3 fw-bold" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("small", { class: "text-muted" }, "Unlicensed", -1 /* HOISTED */);
const _hoisted_13 = {
    key: 0,
    class: "alert alert-warning",
    role: "alert"
};
const _hoisted_14 = {
    class: "list-filter",
    style: { "min-height": "260px", "height": "50vh", "overflow-x": "auto", "background-color": "whitesmoke" }
};
const _hoisted_15 = { class: "table table-sm table-hover mb-0" };
const _hoisted_16 = { style: { "width": "30px", "vertical-align": "middle" } };
const _hoisted_17 = {
    key: 0,
    class: "fa fa-check text-success"
};
const _hoisted_18 = {
    key: 1,
    class: "fa fa-times text-danger"
};
const _hoisted_19 = { class: "fw-bold" };
const _hoisted_20 = { class: "text-muted" };
const _hoisted_21 = { key: 0 };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "2",
    class: "text-center text-muted py-3"
}, "\r\n\t\t\t\t\t\t\t\t\t\t\tNo systems match your search.\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_23 = [
    _hoisted_22
];
const _hoisted_24 = {
    key: 1,
    class: "text-muted small mt-2"
};
const _hoisted_25 = { class: "float-end float-start-sm" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        class: "modal-form-lg",
        modelValue: _ctx.show,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.show) = $event)),
        "header-bg-variant": "normal",
        size: "lg"
    }, {
        title: _withCtx(() => [
            _createTextVNode("\r\n\t\t\tSystem Coverage\r\n\t\t")
        ]),
        footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "secondary",
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.show = false))
                }, {
                    default: _withCtx(() => [
                        _hoisted_26,
                        _createTextVNode(" Close\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        default: _withCtx(() => [
            _createTextVNode(),
            _createVNode(_component_b_container, { clearfix: "" }, {
                default: _withCtx(() => {
                    var _a, _b, _c, _d, _e, _f;
                    return [
                        (_ctx.loaded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createCommentVNode(" Summary Stats "),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("a", null, _toDisplayString((_b = (_a = _ctx.systemCoverage) === null || _a === void 0 ? void 0 : _a.totalSystemCount) !== null && _b !== void 0 ? _b : 0), 1 /* TEXT */)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_6
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("a", null, _toDisplayString((_d = (_c = _ctx.systemCoverage) === null || _c === void 0 ? void 0 : _c.licensedSystemCount) !== null && _d !== void 0 ? _d : 0), 1 /* TEXT */)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_9
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("a", null, _toDisplayString((_f = (_e = _ctx.systemCoverage) === null || _e === void 0 ? void 0 : _e.unlicensedSystemCount) !== null && _f !== void 0 ? _f : 0), 1 /* TEXT */)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_12
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createCommentVNode(" Systems List "),
                                    _createTextVNode(),
                                    _createElementVNode("div", null, [
                                        (_ctx.hasUnlicensedSystems)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "\r\n                            Systems not covered by the license will be excluded from restricted features.\r\n\t\t\t\t\t\t"))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        _createElementVNode("div", null, [
                                            _createVNode(_component_b_form_input, {
                                                modelValue: _ctx.systemsFilter,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.systemsFilter) = $event)),
                                                modelModifiers: { trim: true },
                                                placeholder: "Search for..."
                                            }, null, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("table", _hoisted_15, [
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSystems, (system) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            key: system.systemId
                                                        }, [
                                                            _createElementVNode("td", _hoisted_16, [
                                                                (system.isLicensed)
                                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                                                                    : (_openBlock(), _createElementBlock("i", _hoisted_18))
                                                            ]),
                                                            _createTextVNode(),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("div", _hoisted_19, _toDisplayString(system.systemName), 1 /* TEXT */),
                                                                _createTextVNode(),
                                                                _createElementVNode("div", null, [
                                                                    _createElementVNode("small", null, _toDisplayString(system.companyName), 1 /* TEXT */),
                                                                    _createTextVNode(),
                                                                    _createElementVNode("small", _hoisted_20, " - " + _toDisplayString(system.siteName), 1 /* TEXT */)
                                                                ])
                                                            ])
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */)),
                                                    _createTextVNode(),
                                                    (_ctx.filteredSystems.length === 0)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_21, _hoisted_23))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.systemCoverage && _ctx.systemCoverage.systems.length > _ctx.filteredSystems.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, "\r\n\t\t\t\t\t\t\tShowing " + _toDisplayString(_ctx.filteredSystems.length) + " of " + _toDisplayString(_ctx.systemCoverage.systems.length) + " systems\r\n\t\t\t\t\t\t", 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ];
                }),
                _: 1 /* STABLE */
            }),
            _createTextVNode()
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]));
}
